import React from 'react';
import c from '../w.js';

const IconChevronRightLarge = React.memo(
  c(
    /* @__PURE__ */ React.createElement(
      "path",
      {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M15.5858 12.0001L8.29286 4.70718L9.70708 3.29297L18.4142 12.0001L9.70708 20.7072L8.29286 19.293L15.5858 12.0001Z"
      }
    )
  )
);

export { IconChevronRightLarge };
